module.exports = __webpack_public_path__ + "img/image150.1bd3c818.jpg";